import { useJobsStore } from '@/stores/chatbot/jobsStore';

/**
 * Custom hook to access jobs data for a specific chatbot
 * @param {string} chatbotId - The ID of the chatbot
 * @returns {Object} - Jobs data for the chatbot
 */
export const useJobsData = (chatbotId) => {
  const jobsData = useJobsStore((state) => state.getJobsData(chatbotId));
  
  return jobsData;
};

/**
 * Custom hook to access all jobs data
 * @returns {Object} - All jobs data
 */
export const useAllJobsData = () => {
  const allJobsData = useJobsStore((state) => state.getAllJobsData());
  
  return allJobsData;
};

/**
 * Custom hook to get the total processed count for a chatbot
 * @param {string} chatbotId - The ID of the chatbot
 * @returns {number} - Total processed count
 */
export const useJobsProcessedCount = (chatbotId) => {
  const jobsData = useJobsStore((state) => state.getJobsData(chatbotId));
  
  if (!jobsData?.results) return 0;
  
  return jobsData.results.reduce((total, job) => {
    return total + (job.urls_completed || 0) + (job.urls_failed || 0) + (job.urls_skipped || 0);
  }, 0);
};
